import { Carousel } from "react-responsive-carousel"
const Partner = () => {
  return (
    <div className="partner">
      <div className="partner__texts">
        <h2>Diliput Oleh</h2>
        <h2>Penghargaan</h2>
        <h2>Mitra Kami</h2>
      </div>
      <div className="partner__wrapper">
        <div className="partner__card">
          <img src="/mitra-1.png" alt="icon" />
        </div>
        <div className="partner__card">
          <img src="/mitra-2.png" alt="icon" />
        </div>
        <div className="partner__card">
          <img src="/mitra-3.png" alt="icon" />
        </div>
        <div className="partner__card">
          <img src="/mitra-4.png" alt="icon" />
        </div>
        <div className="partner__card">
          <img src="/mitra-5.png" alt="icon" />
        </div>
        <div className="partner__card">
          <img src="/mitra-6.png" alt="icon" />
        </div>
        <div className="partner__card">
          <img src="/mitra-7.png" alt="icon" />
        </div>
        <div className="partner__card">
          <img src="/mitra-8.png" alt="icon" />
        </div>
        <div className="partner__card">
          <img src="/mitra-9.png" alt="icon" />
        </div>
        <div className="partner__card">
          <img src="/mitra-10.png" alt="icon" />
        </div>
      </div>
    </div>
  )
}

export default Partner
